import { useEffect, useState } from "react";
import { TrendingUp, ArrowRight, Menu, X } from "lucide-react";
import { NAV_LINKS, SITE } from "../config/content";

export function Logo({ size = "text-2xl" }) {
  return (
    <a href="#top" className="flex items-center gap-2 group" data-testid="logo">
      <span className="flex items-center justify-center w-8 h-8 rounded-lg bg-[#22C55E]/10 border border-[#22C55E]/30 group-hover:border-[#22C55E]/70 transition-colors">
        <TrendingUp className="w-4.5 h-4.5 w-[18px] h-[18px] text-[#22C55E]" strokeWidth={2.5} />
      </span>
      <span className={`font-heading ${size} tracking-wide text-white uppercase`}>
        Maru<span className="text-[#22C55E]">bazu</span>
      </span>
    </a>
  );
}

export default function Navbar({ onBook }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 border-b backdrop-blur-md bg-[#070A08]/85 transition-[padding,border-color] duration-300 ${
        scrolled ? "border-[#17231B] py-2.5" : "border-transparent py-5"
      }`}
    >
      <div className="max-w-[1180px] mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between">
        <Logo size={scrolled ? "text-xl" : "text-2xl"} />
        <nav className="hidden md:flex items-center gap-8" aria-label="Primary">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm font-medium text-[#A7B3AA] hover:text-white transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <button
            onClick={onBook}
            data-testid="nav-book-button"
            className="btn-primary hidden sm:inline-flex items-center gap-2 rounded-full bg-[#22C55E] hover:bg-[#16A34A] text-[#04100A] font-bold text-sm px-5 py-2.5 transition-colors"
          >
            Inquire Now
            <ArrowRight className="w-4 h-4 arrow-slide" />
          </button>
          <button
            className="md:hidden text-white p-2"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
            data-testid="nav-menu-toggle"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="md:hidden border-t border-[#17231B] bg-[#070A08]/95 px-6 py-4 flex flex-col gap-4" data-testid="nav-mobile-menu">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-base font-medium text-[#A7B3AA] hover:text-white transition-colors"
            >
              {l.label}
            </a>
          ))}
          <button
            onClick={() => { setOpen(false); onBook(); }}
            data-testid="nav-mobile-book-button"
            className="inline-flex items-center justify-center gap-2 rounded-full bg-[#22C55E] text-[#04100A] font-bold text-sm px-5 py-3"
          >
            Inquire Now <ArrowRight className="w-4 h-4" />
          </button>
        </nav>
      )}
    </header>
  );
}
